var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { get, isEmpty, defaultTo } from "lodash";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useCheckoutContext } from "../../../context/useCheckoutContext";
import { configCardSections } from "../../../shared/constants/CheckoutContants";
import { useCheckoutServiceContext } from "../../../context/useCheckoutServiceContext";
import { useKushkiJsContext } from "../../../context/useKushkiJsContext";
import { IdentificationNumberEnum } from "../../../shared/constants/IdentificationNumberEnum";
import { TransferProcessorsEnum } from "../../../shared/constants/TransferProcessorsEnum";
import { PaymentMethodsEnum } from "../../../shared/constants/PaymentMethodEnum";
export var useCheckoutRecurrentDebitState = function () {
    var form = useForm({
        shouldUnregister: false,
    });
    var _a = useKushkiJsContext(), requestTransferSubscriptionToken = _a.requestTransferSubscriptionToken, requestTransferSubscriptionBankList = _a.requestTransferSubscriptionBankList;
    var _b = useCheckoutContext(), merchantSettingsResponse = _b.merchantSettingsResponse, _c = _b.handlers, setCheckoutLoading = _c.setCheckoutLoading, setCheckoutSection = _c.setCheckoutSection, setCheckoutToken = _c.setCheckoutToken, setIdentity = _c.setIdentity, closeErrorNotification = _c.closeErrorNotification, showErrorNotification = _c.showErrorNotification, amount = _b.amount;
    var handlers = useCheckoutServiceContext().handlers;
    var _d = useState(__assign({ sandboxEnable: false, country: "", merchant_name: "", processor_name: "", prodBaconKey: "", sandboxBaconKey: "" }, defaultTo(merchantSettingsResponse, {}))), merchantSettings = _d[0], setMerchantSettings = _d[1];
    var _e = useState([]), banks = _e[0], setBanks = _e[1];
    var _f = useState("01"), accountType = _f[0], setAccountType = _f[1];
    var _g = useState("CC"), documentType = _g[0], setDocumentType = _g[1];
    var _h = useState(false), termsModal = _h[0], setTermsModal = _h[1];
    var getMerchantSettings = function () { return __awaiter(void 0, void 0, void 0, function () {
        var merchantSettings_1, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setCheckoutLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, handlers.getMerchantSettings()];
                case 2:
                    merchantSettings_1 = _a.sent();
                    setMerchantSettings(merchantSettings_1);
                    setCheckoutLoading(false);
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    console.error(e_1);
                    setCheckoutLoading(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var getBankList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var bankList_1, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setCheckoutLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, requestTransferSubscriptionBankList()];
                case 2:
                    bankList_1 = _a.sent();
                    setBanks(bankList_1);
                    return [3 /*break*/, 5];
                case 3:
                    e_2 = _a.sent();
                    console.error(e_2);
                    return [3 /*break*/, 5];
                case 4:
                    setCheckoutLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var _j = useState(IdentificationNumberEnum[merchantSettings === null || merchantSettings === void 0 ? void 0 : merchantSettings.country]), selectValues = _j[0], setSelectValues = _j[1];
    var _k = useState([
        { label: "", value: "" },
    ]), bankList = _k[0], setBankList = _k[1];
    var _l = useState(""), bankId = _l[0], setBankId = _l[1];
    var _m = useState(get(merchantSettings, "processor_name", TransferProcessorsEnum.PSE)), processorName = _m[0], setProcessorName = _m[1];
    var handleAccountType = function (account) {
        if (account !== null)
            setAccountType(account);
    };
    var handleDocumentType = function (accountType) {
        setDocumentType(accountType);
    };
    useEffect(function () {
        if (!merchantSettings.merchant_name)
            getMerchantSettings();
        getBankList();
    }, []);
    var _o = useState(), country = _o[0], setCountry = _o[1];
    useEffect(function () {
        var _a;
        if (!isEmpty(merchantSettings)) {
            var _b = merchantSettings, country_1 = _b.country, processors = _b.processors;
            setCountry(country_1);
            var selectValue = IdentificationNumberEnum[country_1];
            setSelectValues(selectValue);
            if (!processors)
                return;
            var processorNames = (_a = processors === null || processors === void 0 ? void 0 : processors.transfer) === null || _a === void 0 ? void 0 : _a.filter(function (item) { return item.processorName === TransferProcessorsEnum.PSE; });
            if (!!processorNames[0])
                setProcessorName(processorNames[0].processorName);
        }
    }, [merchantSettings]);
    useEffect(function () {
        if (!isEmpty(banks)) {
            var tempBanks = banks.map(function (bank) { return ({
                label: bank.name,
                value: bank.code,
            }); });
            setBankList(__spreadArrays(tempBanks.slice(1)));
        }
    }, [banks]);
    var handleSubmit = function (formData) { return __awaiter(void 0, void 0, void 0, function () {
        var transferSubscriptionTokenRequest, tokenResponse, e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setCheckoutLoading(true);
                    setIdentity(formData.identificationNumber);
                    transferSubscriptionTokenRequest = {
                        accountNumber: formData.accountNumber,
                        accountType: accountType,
                        bankCode: bankId,
                        currency: amount.currency,
                        documentNumber: formData.identificationNumber,
                        documentType: documentType,
                        email: formData.email,
                        lastName: formData.name,
                        name: formData.name,
                        totalAmount: amount.total,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, requestTransferSubscriptionToken(transferSubscriptionTokenRequest)];
                case 2:
                    tokenResponse = _a.sent();
                    closeErrorNotification();
                    setCheckoutToken(__assign(__assign({}, tokenResponse), { additionalConfig: {
                            documentNumber: formData.identificationNumber,
                            documentType: documentType,
                            name: formData.name,
                        }, contactDetails: {
                            email: formData.email,
                        }, paymentMethod: PaymentMethodsEnum.TRANSFER_SUBSCRIPTION }));
                    if (get(tokenResponse, "secureService") !== undefined)
                        setCheckoutSection(configCardSections.confrontaStart);
                    return [3 /*break*/, 5];
                case 3:
                    e_3 = _a.sent();
                    showErrorNotification(e_3);
                    console.error(e_3);
                    return [3 /*break*/, 5];
                case 4:
                    setCheckoutLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return {
        accountType: accountType,
        amount: amount,
        bankList: bankList,
        country: country,
        documentType: documentType,
        form: form,
        handlers: {
            handleAccountType: handleAccountType,
            handleDocumentType: handleDocumentType,
            handleSubmit: handleSubmit,
        },
        merchantSettings: merchantSettings,
        processorName: processorName,
        selectValues: selectValues,
        setTermsModal: setTermsModal,
        setBankId: setBankId,
        termsModal: termsModal,
    };
};
